module.exports = __webpack_public_path__ + "media/images/pr_detail/1-e76344472087ea4bcac377af0f5d4ace.png";